import styled, { css } from 'styled-components';

export const Container = styled.div``;

interface InfoProps {
  isFocused: boolean;
}

export const Info = styled.main<InfoProps>`
  max-width: 1120px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  place-content: center;

  align-items: center;
  justify-items: center;

  h1 {
    width: 100vw;

    text-align: center;

    margin-top: 24px;
    color: #2c73e9;
  }

  .inputDiv {
    background-color: #fbfbfb;

    /* filter: drop-shadow(0px 2px 10px rgba(0, 0, 0, 0.25)); */
    border-radius: 8px;
    padding: 16px;
    min-width: 350px;

    display: flex;
    align-items: center;

    border: 2px solid #aaa;
    color: #999999;

    ${(props) =>
      props.isFocused &&
      css`
        border: 2px solid #2c73e9;
        color: #2c73e9;
      `}

    input {
      flex: 1;
      border: 0;
      background: transparent;

      color: #000000;

      &::placeholder {
        color: #999999;
      }
    }
    svg {
      margin-right: 16px;
    }
  }
`;

export const Cards = styled.div`
  display: flex;
  flex-wrap: wrap;

  place-content: center;

  align-items: center;
  justify-items: center;
  margin: 24px auto;

  button {
    margin: 6px 8px;
    width: 350px;
    padding: 8px;
  }
`;
